import React from "react";
import Galery from "../components/galery/galery";

export default function GaleryRouter() {
  return <Galery />;
}
